export const GET_QUESTIONS = 'GET_QUESTIONS';
export const GET_ADMIN_QUESTIONS = 'GET_ADMIN_QUESTIONS';
export const QUESTION_LOADING = 'QUESTION_LOADING';
export const GET_QUESTION = 'GET_QUESTION';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const ADD_QUESTION = 'ADD_QUESTION';
export const DELETE_QUESTION = 'DELETE_QUESTION';
export const GET_QUESTIONS_BY_SURVEY = 'GET_QUESTIONS_BY_SURVEY';
